import React from 'react';
import './style.css'
import { Link } from 'react-router-dom';
import ChangeLang from '../../../components/changeLang'
import QRCode from "react-qr-code";

const Index = ({ showBack = true, showFooterBack = true, children, showLogo=true, showRedes=true }) => {
   
    const [showModal, setShowModal] = React.useState(false);
  
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");

      const [showBoost, setshowBoost] = React.useState(false);
  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
        marginTop: 10,
        background: '#b8272e'
      }}>
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

            <div className='nav-menu-bar' style={{
              marginTop: -4 ,
              width: '100%',
              position: 'relative'
            
            }}>
               
              {showLogo &&
              <div style={{
              background: '#b8272e',
              paddingTop: 20,
              paddingBottom: 20,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
                justifyContent: 'space-between',
            
              }}>
                <Link to={`/`} style={{
                     zIndex: 999
                 }}>
                
                <img
                style={{
                  width: 200,
                  
              }}
              src={require('./assets/logo.png')}
              alt="Logo"
              /> 
               </Link>
              
              {showBack ? (
                 <div
                            
                        style={{
                    width: 170,
                    height: 52,
                    display: 'flex',
                    textAlign: 'center',
                    alignItems: 'center',
                          justifyContent: "center",
                    cursor: 'pointer',
                        
                          marginRight: 10,
                    zIndex: 999
                    

                  }}>
                    <img style={{
                      width: 170,
                      height: 52
                    }} src={require("./assets/back.png") } />
                  </div>
              ): (
                  
              <div style={{ display: 'flex',
                      alignItems: 'center',
                          position: 'relative',
                          zIndex: 999,
                          justifyContent: 'space-between',}}>
                    <div onClick={()=>setShowModal('https://www.instagram.com/donalexrestaurantenj/')} target='_blank'> <img
                    style={{
                      width: 28,
                        height: 28,
                        marginInline: 10
                    
                  }}
                  src={require('./assets/instagram.png')}
                  alt="Logo"
                  /> 
                  </div>

                  <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/donalexrestaurantNJ')}> 
                    
                    
                  <img
                    style={{
                        width: 28,
                          height: 28,
                          marginInline: 10
                  }}
                  src={require('./assets/facebook.png')}
                  alt="Logo"
                  /> 
                        </div>
                        <div target='_blank' onClick={()=>setShowModal('https://g.co/kgs/qoFnmnH')}> 
                    
                    
                  <img
                    style={{
                        width: 28,
                          height: 28,
                          marginInline: 10
                  }}
                  src={require('./assets/globe.png')}
                  alt="Logo"
                  /> 
                        </div>
                         <ChangeLang/>
              
                <div>
                
                </div>
              </div>
              )}
              </div>
              }
              


            

            </div>
            {children}

            
              {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }

               {showModalPincode &&
                <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                  
                  <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                    <img
                        onClick={()=>setShowModalPincode(false)}
                      style={{
                        position: 'absolute',
                        top: -10,
                        
                                  width: 40,
                                    height: 40,
                                    marginInline: 10,
                                    objectFit: 'contain',
                                    position: 'absolute',
                                    right: -10,
                                    zIndex: 9999
                                
                              }}
                        src={require('./assets/close.png')}
                        alt="Logo"
                    /> 
                    <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                    <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                      setScret(e.target.value)
                    }} />
                    <br /><br />
                    
                    <div style={{display: 'flex', gap: 20}}>
                      <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                        <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                      </div>
                      <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                        <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                    </div>
                  </div>
                  </div>
                </div>
            }

              
            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              viewBox={`0 0 256 256`}
            />
            </div>}

             <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: 40,
                display: "flex",
                alignItems:'center',
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
                background: "black"
              }}>
                  <div
                    onClick={()=> setshowBoost(true)}
                style={{display: 'flex',flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#fff',
                      fontWeight: '800',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by 
                </p>
                <img src={require('./assets/isotipo.png')} style={{
                  objectFit: 'contain',
                  width: 40,
                  height: 40
                }} />
                 <p
                  style={{
                      color: '#fff',
                      fontWeight: '800',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
              boostyourmenu.com V1.1
                </p>
              </div>
              <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 25,
                            height: 25,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 

            </div>
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;